import { render, staticRenderFns } from "./FeedbackTab.vue?vue&type=template&id=271f5dac&scoped=true&"
import script from "./FeedbackTab.vue?vue&type=script&lang=js&"
export * from "./FeedbackTab.vue?vue&type=script&lang=js&"
import style0 from "./FeedbackTab.vue?vue&type=style&index=0&id=271f5dac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "271f5dac",
  null
  
)

export default component.exports